import { render } from "./CardReplies.vue?vue&type=template&id=04f2da6a&scoped=true"
import script from "./CardReplies.vue?vue&type=script&lang=js"
export * from "./CardReplies.vue?vue&type=script&lang=js"

import "./CardReplies.vue?vue&type=style&index=0&id=04f2da6a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04f2da6a"]])

export default __exports__